import { Button } from "@material-ui/core";
import { isAnnouncementModalOpen } from "../../../selectors/announcement";
import React, { useCallback } from "react";
import { createToggleAnnouncementModalAction } from "../../../actions/modals";
import { useSelector, useDispatch } from "react-redux";

import "./styles.css";
import WebsiteModal from "../../Modal";
import { openOrderingModal } from "../../../utils/redirect";

const AnnouncementModal: React.FC = () => {
  const dispatch = useDispatch();
  const isOpen = useSelector(isAnnouncementModalOpen);

  const handleClose = useCallback(() => {
    dispatch(createToggleAnnouncementModalAction({ isOpen: false }));
  }, [dispatch]);

  const handleOrderNow = useCallback(() => {
    dispatch(createToggleAnnouncementModalAction({ isOpen: false }));
    openOrderingModal(dispatch);
  }, [openOrderingModal, dispatch]);

  return (
    <WebsiteModal
      open={isOpen}
      onClose={handleClose}
      aria-labelledby={"Announcement"}
      aria-describedby={"Announcements"}
    >
      <>
        <h1>
          🎉 Big News from New Peking Chinese Restaurant — A Thank You and an
          Exciting Announcement
        </h1>
        <p>
          After 22 amazing years, it’s time for us to pass the wok to the next
          generation. 🍜
        </p>

        <p>
          New Peking hasn’t just been a restaurant — it’s been a place where
          families grew up, kids celebrated birthdays, The Peking duck, our
          hand-folded egg rolls & General Tso chicken became a part of your
          weekly routines. We are so grateful for every shared meal and every
          memory made here. 💛
        </p>

        <p>
          Soon, this space will become May Thai Kitchen — bringing vibrant Thai
          flavors to Crystal Lake! 🇹🇭✨
        </p>

        <p>
          We’ve met the new owners, and their passion is contagious. They
          promise to keep the same warmth and heart you’ve always known… plus a
          few delicious surprises!{" "}
        </p>

        <p>
          🧡 A Special Bridge: Some of your favorite New Peking dishes will stay
          on the menu — because we know you can’t live without them. 😉
        </p>

        <p>
          Heads up: The restaurant will close briefly for kitchen upgrades as
          the new team prepares for their upcoming launch.
        </p>
        <p>A new story begins.</p>
        <p>May Thai Kitchen — coming soon.</p>
      </>
    </WebsiteModal>
  );
};

export default AnnouncementModal;
